import { createContext, Dispatch } from 'react'

export type ContextProps = {
  setActiveIndex: Dispatch<number>
  activeIndex: number
}

export const STLContext = createContext<Partial<ContextProps>>({})
